import type { ShiftProductionFormPayload } from "../../../shared/shift-production-form/contracts";

export type PendingCreateAttempt = Readonly<{
  operatorId: string;
  idempotencyKey: string;
  payload: ShiftProductionFormPayload;
}>;

export function snapshotPayload(payload: ShiftProductionFormPayload) {
  return structuredClone(payload);
}

export function beginCreateAttempt(
  operatorId: string,
  idempotencyKey: string,
  payload: ShiftProductionFormPayload,
): PendingCreateAttempt {
  return { operatorId, idempotencyKey, payload: snapshotPayload(payload) };
}

export function payloadChanged(
  attempted: ShiftProductionFormPayload,
  latest: ShiftProductionFormPayload,
) {
  return JSON.stringify(attempted) !== JSON.stringify(latest);
}

export function createSerialTaskQueue() {
  let tail: Promise<void> = Promise.resolve();
  return {
    run<T>(task: () => Promise<T>) {
      const result = tail.then(task);
      tail = result.then(
        () => undefined,
        () => undefined,
      );
      return result;
    },
  };
}
